import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { TextView } from '../../ui_canvas_engine/TextView.ts';
import { GameFont } from '../../GameFont.ts';
import { GameColor } from '@colonist/ui-game';
import { UIGameHoverResourceInfoView } from '../UIGameHoverResourceInfoView.ts';
import { SectionBgView } from '../../ui_canvas_engine/SectionBgView.ts';
import { SpriteButtonView } from '../../ui_canvas_engine/SpriteButtonView.ts';
import { UIGameShakeAnimation } from '../../ui_canvas_engine/animation/UIGameShakeAnimation.ts';
import { Point } from '@colonist/game-mechanic-validators';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIPlacementConfirmationButton extends SectionBgView {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.PlayerControllerStateUpdated:
                this.updateButtonState();
                break;
            default:
                break;
        }
    }
    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this);
        super.destroy();
    }
    shakeButton() {
        if (this.buttonShakeAnimation != undefined) this.buttonShakeAnimation.stop();
        this.buttonShakeAnimation = new UIGameShakeAnimation(this.button).start();
    }
    addBadge(myColor, canTakeAction, amount) {
        if (amount === undefined) return;
        const size = this.height / 3;
        const buttonBorderX = this.width * 0.1;
        const buttonBorderY = this.height * 0.04;
        const badgeX = this.width - size;
        const badgeTexture = UIGameSpriteHandler.getButtonBadgeForPlayer(myColor);
        const badgeSprite = new SpriteView(badgeX - buttonBorderX, buttonBorderY, size, size, this.button.viewContainer, badgeTexture);
        this.button.addAsset(badgeSprite);
        this.createCardCountText(amount);
    }
    createCardCountText(count) {
        const buttonBorderX = this.width * 0.1;
        const buttonBorderY = this.height * 0.04;
        const countText = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: count
            }
        };
        const countTextView = new TextView(countText, this.width * 0.8 - buttonBorderX, buttonBorderY, this.width, this.height, this.button.viewContainer, undefined, undefined, false);
        const fontSize = this.height / 5.5;
        const maxNumberForOneDigitText = 9;
        if (count > maxNumberForOneDigitText) countTextView.x -= this.width / 15;
        const colorDarkGrey = GameColor.getColor(GameColor.Color.DarkGrey);
        const colorOffWhite = GameColor.getColor(GameColor.Color.OffWhite);
        countTextView.changeStyle({
            fontSize: fontSize + 'px',
            fill: colorOffWhite,
            fontWeight: GameFont.Weight.Bold,
            stroke: colorDarkGrey,
            strokeThickness: 2
        });
        return countTextView;
    }
    addResourceCardStates(cardEnums, cardInventory) {
        this.resourceCardStates = new UIGameHoverResourceInfoView(cardEnums, this, this, cardInventory, false);
    }
    updateButtonState() {
        var _this_resourceCardStates;
        if (!this.hoverActionController) return;
        const updatedParameters = this.hoverActionController.getConfirmationParameters(this.placementIndex);
        const cardInventory = this.uiGameManager.cardController.getCardInventory();
        this.canTakeAction = updatedParameters.canTakeAction;
        if (updatedParameters.canTakeAction) {
            this.button.activateOpacity();
        } else {
            this.button.inactivateOpacity();
        }
        (_this_resourceCardStates = this.resourceCardStates) === null || _this_resourceCardStates === void 0 ? void 0 : _this_resourceCardStates.updateCardViews(cardInventory);
    }
    constructor(x, y, w, h, container, uiGameManager, action, texture, canTakeAction, myColor, bankActionAmount, hoverActionController, placementIndex){
        super(x, y, w, h, container, true);
        this.uiGameManager = uiGameManager;
        this.canTakeAction = canTakeAction;
        this.hoverActionController = hoverActionController;
        this.placementIndex = placementIndex;
        this.button = new SpriteButtonView(0, 0, w, h, this);
        this.button.updateAction(()=>{
            var _this_resourceCardStates;
            if (this.canTakeAction) return action();
            this.shakeButton();
            (_this_resourceCardStates = this.resourceCardStates) === null || _this_resourceCardStates === void 0 ? void 0 : _this_resourceCardStates.flickerMissingCards();
        });
        this.center = new Point(x + w / 2, y + h / 2);
        this.button.addCenteredIcon(texture);
        this.addBadge(myColor, canTakeAction, bankActionAmount);
        if (canTakeAction) return;
        this.button.inactivateOpacity();
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
